import { Component } from '@angular/core';
import { TrelloService } from 'app/trello/services/trello.service';

@Component({
  selector: 'app-help-component',
  templateUrl: './help.component.html',
})
export class HelpComponent {

  constructor(
    private readonly trelloService: TrelloService, // required
  ) {
  }

}
